import React, { useState } from "react";
import '../Bathroom/BathroomCleaningInfo.css'; // Import a CSS file for kitchen cleaning styles
import ThumbImg from '../../Images/Serviceimg/thumbs-up.png';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; // Import the expand icon
import RemoveImg from '../../Images/Serviceimg/remove.png'

const KitchenCleaningInfo = () => {
    const [activeIndex, setActiveIndex] = useState(null); // State to manage the active question

    const handleToggle = (index) => {
        // Toggle the active index on click
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="cleaning-card">
            <div className="section-heading">Included</div>
            <ul className="service-list">
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Surface Cleaning - Wiping down all countertops and surfaces to remove dust and grime
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Appliance Cleaning - Cleaning of exterior surfaces of kitchen appliances, including the refrigerator, oven, and microwave
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Cabinet Cleaning - Wiping down cabinet faces and removing sticky residues
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Sink Cleaning - Scrubbing and disinfecting the sink area
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Floor Cleaning - Sweeping and mopping kitchen floors with suitable cleaning solutions
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Backsplash Cleaning - Detailed cleaning of the backsplash area to remove stains and splatters
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Final Touch-Up - Ensuring all areas are clean and presentable
                </li>
            </ul>

            <div className="section-heading">Excluded</div>
            <ul className="service-list">
                <li className="service-item">
                    <span className="thumb-icon"><img src={RemoveImg} alt="" /></span>
                    Deep Cleaning of Inside Appliances
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={RemoveImg} alt="" /></span>
                    Heavy Duty Cleaning of Ovens and Range Hoods
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={RemoveImg} alt="" /></span>
                    Removal of Mold or Mildew
                </li>
            </ul>

            <div className="section-heading">Frequently Asked Questions</div>

            {[
                { question: "Is this service applicable for all types of kitchens?", answer: "Yes, this service can be performed in all types of kitchens, whether residential or commercial." },
                { question: "Do I need to be present during the cleaning?", answer: "It's not necessary, but we recommend being available for any specific instructions." },
                { question: "Can the cleaners clean inside the refrigerator?", answer: "No, this service does not include deep cleaning of the inside of appliances." },
                { question: "How long does the kitchen cleaning service take?", answer: "The duration typically takes 1-3 hours, depending on the kitchen size." },
            ].map((faq, index) => (
                <div className="faq-accordion" key={index}>
                    <div className="faq-question">
                        <div>{faq.question}</div>
                        <ExpandMoreIcon className={`faq-arrow ${activeIndex === index ? "rotate" : ""}`} onClick={() => handleToggle(index)} />
                    </div>
                    {activeIndex === index && (
                        <div className="faq-answer">
                            <div>{faq.answer}</div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default KitchenCleaningInfo;
